import { FRAME_OPTIONS, type ExportFrame } from "../frames";

type Props = {
  /** `template.aspectRatio` của mẫu đang chọn (ví dụ "4:5") — khung duy nhất thật sự tải được. */
  currentAspectRatio: string | null;
};

/**
 * Khu vực "Tải về" theo khung — hiện đủ 5 khung theo docs/72-growth-viral.md §4.1, nhưng CHỈ
 * khung trùng với `template.aspectRatio` của mẫu đang chọn là tải được thật.
 *
 * TẠI SAO: đã xác nhận bằng curl (xem src/frames.ts) rằng apps/api chỉ có `POST /qr/render`
 * (render đúng khung gốc template), KHÔNG có endpoint đa khung nào dù package
 * `@qrstudio/creative-renderer` nội bộ đã hỗ trợ đủ (`renderFrames`, `listExportFrames`).
 * Không tự bịa endpoint — 4 khung còn lại hiện trạng thái "Sắp có", không có nút tải, để không
 * hứa hẹn sai với người dùng. Nút tải cho khung khả dụng nằm ở các nút "Tải ảnh về"/"Tải ảnh
 * PNG" chính phía trên (không lặp lại ở đây để tránh hai bộ nút tải cùng làm một việc).
 */
export default function DownloadFrames({ currentAspectRatio }: Props) {
  const availableFrame = FRAME_OPTIONS.find((f) => f.frame === currentAspectRatio)?.frame ?? null;

  return (
    <div className="download-frames">
      <p className="download-frames-title">Khung xuất</p>
      <div className="frame-chip-row" role="list">
        {FRAME_OPTIONS.map((f) => (
          <FrameChip key={f.frame} frame={f.frame} label={f.label} hint={f.hint} available={f.frame === availableFrame} />
        ))}
      </div>
      <p className="hint-text small">
        Khung "{FRAME_OPTIONS.find((f) => f.frame === availableFrame)?.label ?? "hiện tại"}" tải được ngay ở nút phía
        trên. Các khung còn lại đang được hoàn thiện, sẽ có sớm.
      </p>
    </div>
  );
}

function FrameChip({
  label,
  hint,
  available,
}: {
  frame: ExportFrame;
  label: string;
  hint: string;
  available: boolean;
}) {
  return (
    <div
      className={`frame-chip ${available ? "frame-chip-available" : "frame-chip-soon"}`}
      role="listitem"
      title={available ? hint : `${hint} — sắp có`}
      aria-disabled={!available}
    >
      <span className="frame-chip-label">{label}</span>
      {available ? <span className="frame-chip-badge frame-chip-badge-ok">✓ Tải được</span> : <span className="frame-chip-badge">Sắp có</span>}
    </div>
  );
}
